<template>
  <div class="card">
    <div class="print">
      <div class="docdate text-capitalize">
        {{ offerTypeText }} indicatief uitkeringsschema {{ today }}
      </div>
      <img id="db-logo" src="../../../assets/db/DB-logo1.svg" />
      <table class="new">
        <tr>
          <th>Indicatief uitkeringsschema</th>
        </tr>
        <tr>
          <td>
            U start met een kapitaal van <b>&euro; {{ formatPrice(amount, true) }},-</b>
          </td>
        </tr>
        <tr>
          <td>
            Uw eerste uitkering is {{ offerType == 4 ? '' : '(bruto)' }}
            <b>
              &euro;
              {{
                formatPrice(
                  Number(
                    offerType == 1 || offerType == 4
                    ? charts.chart2[0][2]
                    : offerType != 0 && offerType != 5
                      ? charts.chart1[0][2]
                      : charts.chart2[0][1]
                  ),
                  true,
                )
              }},-
            </b>
            <template v-if="!firstPayment">
              per jaar{{
                paymentPeriod == 'Per maand'
                  ? ` of &euro; ${formatPrice(
                      Number(
                        offerType == 1 || offerType == 4
                        ? charts.chart2[0][2]
                        : offerType != 0 && offerType != 5
                          ? charts.chart1[0][2]
                          : charts.chart2[0][1],
                      ) / 12,
                      true,
                    )}- per maand`
                  : ''
              }}{{
                paymentPeriod == 'Per kwartaal'
                  ? ` of &euro; ${formatPrice(
                      Number(
                        offerType == 1 || offerType == 4
                        ? charts.chart2[0][2]
                        : offerType != 0 && offerType != 5
                          ? charts.chart1[0][2]
                          : charts.chart2[0][1],
                      ) / 4,
                      true,
                    )},- per kwartaal`
                  : ''
              }}{{
                paymentPeriod == 'Per halfjaar'
                  ? ` of &euro; ${formatPrice(
                      Number(
                        offerType == 1 || offerType == 4
                        ? charts.chart2[0][2]
                        : offerType != 0 && offerType != 5
                          ? charts.chart1[0][2]
                          : charts.chart2[0][1],
                      ) / 2,
                      true,
                    )}- per half jaar`
                  : ''
              }}.
            </template>
            <template v-else>
              per jaar.
            </template>
          </td>
        </tr>
        <tr>
          <td>
            U ontvangt de uitkering <b>{{ duration }} jaar</b>
          </td>
        </tr>
      </table>

      <p class="msg">
        Uw {{ offerTypeText }} gaat van start nadat uw getekende indicatief uitkeringsschema en
        het geld door ons is ontvangen. {{offerType == 4 ? '' : `Wij houden
        op de uitkering van de ${offerTypeText} inkomstenbelasting in.`}}
      </p>

      <h3>De hoogte van uw uitkering verandert</h3>
      <p>
        Periodiek berekenen we de hoogte van uw nieuwe uitkering. Dat doen we in ieder geval elk
        jaar op basis van gerealiseerd resultaat.
      </p>

      <h3>We schatten hoe hoog uw {{ offerTypeText }} is over een aantal jaar</h3>
      <p>
        Uw uitkering hangt af van de beleggingsresultaten. Toch geven we u graag een idee van wat
        er kan gebeuren. Hieronder ziet u drie voorbeelden. Een bedrag bij een
        <strong>Optimistische</strong> ontwikkeling van uw {{ offerTypeText }}. Een bedrag voor
        als het <strong>Neutraal</strong> (ons netto voorbeeldrendement) gaat. En eentje bij een
        <strong>Pessimistische</strong> ontwikkeling.
      </p>

      <table class="new">
        <colgroup>
          <col>
          <col>
          <col :style="
            [paymentPeriod == 'Per maand' ? {visibility: 'visible'} : {visibility: 'collapse'}]
          ">
          <col :style="
            [paymentPeriod == 'Per kwartaal' ? {visibility: 'visible'} : {visibility: 'collapse'}]
          ">
          <col :style="
            [paymentPeriod == 'Per halfjaar' ? {visibility: 'visible'} : {visibility: 'collapse'}]
          ">
        </colgroup>
        <tr>
          <th>Geschatte bruto uitkering in {{ new Date().getFullYear() + duration }}</th>
          <th>Per jaar</th>
          <th>Per maand</th>
          <th>Per kwartaal</th>
          <th>Per Halfjaar</th>
        </tr>
        <tr>
          <td>{{ getCols3()[1].label }}</td>
          <td>
            &euro;
            {{
              formatPrice(
                offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][1]
                  : charts.chart4[Number(duration) - 1][1],
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][1]
                  : charts.chart4[Number(duration) - 1][1]) / 12,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][1]
                  : charts.chart4[Number(duration) - 1][1]) / 4,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][1]
                  : charts.chart4[Number(duration) - 1][1]) / 2,
                true,
              )
            }},-
          </td>
        </tr>
        <tr>
          <td>{{ getCols3()[2].label }}</td>
          <td>
            &euro;
            {{
              formatPrice(
                offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][2]
                  : charts.chart4[Number(duration) - 1][2],
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][2]
                  : charts.chart4[Number(duration) - 1][2]) / 12,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][2]
                  : charts.chart4[Number(duration) - 1][2]) / 4,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][2]
                  : charts.chart4[Number(duration) - 1][2]) / 2,
                true,
              )
            }},-
          </td>
        </tr>
        <tr>
          <td>{{ getCols3()[3].label }}</td>
          <td>
            &euro;
            {{
              formatPrice(
                offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][3]
                  : charts.chart4[Number(duration) - 1][3],
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][3]
                  : charts.chart4[Number(duration) - 1][3]) / 12,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][3]
                  : charts.chart4[Number(duration) - 1][3]) / 4,
                true,
              )
            }},-
          </td>
          <td>
            &euro;
            {{
              formatPrice(
                (offerType == 1 || offerType == 4
                  ? charts.chart3[Number(duration) - 1][3]
                  : charts.chart4[Number(duration) - 1][3]) / 2,
                true,
              )
            }},-
          </td>
        </tr>
      </table>

      <p class="msg">
        <b>Let op!</b> Deze bedragen zijn niet zeker. In uitzonderlijke gevallen kan uw werkelijke
        uitkering nog hoger of nog lager zijn. U moet voor uzelf nagaan of een lagere uitkering
        past bij uw uitgavenpatroon. Een adviseur kan u hierbij helpen. Neem hierover gerust
        contact met ons op via 020 555 0055.
      </p>
    </div>
    <div class="pagefooter">
      &copy; info@doelbeleggen.nl - 020 555 0055 - Dorpsstraat 34 - 1182 JE Amstelveen
    </div>
    <div class="pagenumber" />
    <div class="break" />
  </div>
</template>

<script>
export default {
  name: 'leefrentePageOverview',
  props: {
    amount: {
      type: Number,
      required: true,
      default: 100,
    },
    duration: {
      type: Number,
      required: true,
      default: 10,
    },
    offerType: {
      type: Number,
      required: true,
      default: 1,
    },
    firstPayment: Number,
    paymentPeriod: {
      type: String,
      required: true,
      default: 'Per maand',
    },
    profile: {
      type: Number,
      required: true,
    },
    charts: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      today: new Date().toLocaleString('nl-NL').split(' ')[0].replace(/\//g, '-'),
    };
  },
  computed: {
    offerTypeText() {
      if (this.offerType === 1) {
        return 'Leefrente';
      }
      if (this.offerType === 4) {
        return 'netto lijfrente';
      }
      return 'uitkerende lijfrente';
    },
  },
  methods: {
    getCols3() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: this.offerType === 2 || this.offerType === 3
          ? 'Slechte markt (-2%)'
          : 'Pessimistisch (-2%)',
      });
      cols.push({
        type: 'number',
        label: this.offerType === 2 || this.offerType === 3
          ? `Voorbeeldmarkt (${this.profile}%)`
          : `Neutraal (${this.profile}%)`,
      });
      cols.push({
        type: 'number',
        label: this.offerType === 2 || this.offerType === 3
          ? 'Goede markt (6%)'
          : 'Optimistisch (8%)',
      });
      return cols;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
</style>
